// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// Order matters: tokens declares the custom properties, base consumes them,
// and App.css consumes both. CRA concatenates in import order.
import "./styles/tokens.css";
import "./styles/base.css";

import App from "./App";

// Installed before render so it catches rejections during startup.
window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (event.reason == null) {
      console.warn("⚠️ Ignoring null unhandledrejection");
      event.preventDefault();
      return;
    }
    console.error("Unhandled promise rejection:", event.reason);
  },
  true
);

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// The two console.log calls that printed SITE_KEY and the Firebase API key are
// removed. Both keys are public by design so this was never a leak, but they
// were noise in the production console that advertised the configuration.

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={SITE_KEY}
    scriptProps={{ async: true, defer: true, appendTo: "head" }}
  >
    {/* BrowserRouter, not HashRouter. URLs become
          https://innermindsvoice.com/auction/item/item1
        instead of
          https://innermindsvoice.com/#/auction/item/item1

        Two things make this safe here:
          1. firebase.json already has {"source": "**", "destination":
             "/index.html"}, so deep links are served the app shell rather
             than 404ing.
          2. That catch-all is listed AFTER the /api/** rewrite, so API calls
             still reach Cloud Run.

        No `basename` is needed: the site is served from the domain root.

        ⚠️ Every QR code changes. Regenerate and reprint them all — an old
        printed code pointing at /#/auction/item/x will land a visitor on the
        homepage instead of the painting in front of them. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleReCaptchaProvider>
);